<div class="notification-popover">
  <p-overlayPanel #overlayPanel styleClass="alc-overlay-panel alc-overlay-panel-without-padding">
    <div *ngIf="!notifications.length" class="notification-popover__no-data">{{ 'noNotifications' | transloco }}</div>
    <div *ngIf="!!notifications.length" class="notification-popover__data">
      <div class="notification-popover__data-title">{{ 'last30Notifications' | transloco }}</div>
      <div *ngFor="let notification of notifications" class="notification">
        <div class="notification__content" [cpakTrackClick]="ButtonNamesGA.OpenPack" (click)="navigateToPack(notification.pakId, notification.pakType)">
          <div class="notification__title">{{ notification.subject }}</div>
          <div class="notification__subtitle">
            <div
              class="notification__from"
              tooltipStyleClass="alc-default-bottom-tooltip"
              tooltipPosition="bottom"
              [pTooltip]="('from' | transloco) + ' ' + notification.fromUser"
            >
              {{ 'from' | transloco }} {{ notification.fromUser }}
            </div>
            <div
              class="notification__date"
              tooltipStyleClass="alc-default-bottom-tooltip"
              tooltipPosition="bottom"
              [pTooltip]="(notification.date | cpakDate) || ''"
            >
              {{ notification.date | cpakDate }}
            </div>
          </div>
          <button
            pButton
            pRipple
            type="button"
            class="p-button-text notification__open-button alc-custom-text-button"
            [label]="'openPack' | transloco"
          ></button>
        </div>
        <!--This button is out of scope, should be implemented later-->
        <button
          *ngIf="false"
          pButton
          type="button"
          icon="alc-icon-close-dark"
          class="p-button-raised p-button-rounded cross-button notification__close-button"
        ></button>
      </div>
    </div>
  </p-overlayPanel>
</div>
